import { useUserData } from '@/app/queries/MeetingQuery/context';

import Logo from '@/assets/logo.svg?react';

export default function Title() {
  const userData = useUserData();

  return (
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <Logo className="size-10 shrink-0" />
      <div className="flex min-w-0 flex-col">
        <h1 className="truncate text-base text-white">
          Onsite with Ergeon
        </h1>
        <p className="truncate text-xs text-slate-300">
          {userData.address}
        </p>
      </div>
    </div>
  );
}
